window.Drupal.behaviors.copasLanding = {
  attach: (context) => {
    window.addEventListener("DOMContentLoaded", () => {
      // Agrega la imagen arriba del botón del SKU
      const pictureElement = document.querySelector('#ab_paco_96 .abi-paco__sku-picture');
      const descriptionElement = document.querySelector('#ab_paco_96 .abi-paco__sku-description');

      if (pictureElement && descriptionElement) {
        // Clona el contenido del elemento .abi-paco__sku-picture
        const pictureClone = pictureElement.cloneNode(true);

        pictureClone.classList.add('abi-paco__sku-picture--insert');
        pictureElement.classList.add('abi-paco__sku-picture--none');
        
        // Inserta el contenido clonado después del elemento .abi-paco__sku-description
        descriptionElement.parentNode.insertBefore(pictureClone, descriptionElement.nextSibling);
      }

      // Edita el texto del content fold
      const contentWrapper = document.querySelector('#ab_paco_91 .abi-paco__content--wrapper');

      if (contentWrapper) {
        const contentCards = contentWrapper.querySelectorAll('.abi-paco__content-card');

        contentCards.forEach(contentCard => {
          const cardDescription = contentCard.querySelector('.abi-paco__content-card-description');
          const cardDescriptionText = cardDescription.textContent;

          // Verifica si cumple con los criterios de un número seguido de un punto
          if (/^\d+\./.test(cardDescriptionText)) {
            const separatedText = cardDescriptionText.split(/\d+\./);
            separatedText.shift();

            const newParagraphs = separatedText.map((text, i) => {
              const trimmedText = text.trim();
              return `<p class="abi-paco__content-card-description" style="padding:0;margin:0">${i+1}. ${trimmedText}</p>`;
            });

            cardDescription.innerHTML = newParagraphs.join('');
          }
        });
      }

      // Dataslayer
        const paginationContent = document.querySelectorAll('#ab_paco_86 .slider_dot_btn')

        paginationContent.forEach(btn => {
          btn.addEventListener('click', () => {
            const btnContext = btn.textContent

            dataLayer.push({
              'event': 'GAEvent',
              'event_category': 'Content',
              'event_action': 'Card',
              'event_label': btnContext,
              'interaction':'true',
              'component_name': '[data-cy=btn_number_sec]',
              'element_text': 'Números Banner Secundario',
            });
          })
        })
    });
  }
};
